import type { HelpFile } from '../../types/help'
import { HeaderTestIds } from '../../../testids/HeaderTestIds'

export const headerHelp: HelpFile = {
  texts: {
    [HeaderTestIds.headerUtilityNav]: null,
  },
}
